export default __webpack_public_path__ + "dist/media/Resend.9e541464.svg";